import React from "react";

import './LoadingSpinner.style.scss';
const LoadingSpinner = () => {
    return (
        <div className="LoadingSpinner">
            <div className="spinner" />
        </div>
    );
}

export default LoadingSpinner;